<template>
  <div class="skeleton-card">
    <div class="skeleton-avatar" />
    <div class="skeleton-text">
      <div class="line line-1" />
      <div class="line line-2" />
    </div>
  </div>
</template>

<style scoped>

.skeleton-card {
  display: flex;
  align-items: center;

  padding: 12px 0;

  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  gap: 16px;
  width: 100%;

  box-sizing: border-box;
}

.skeleton-avatar {
  width: 48px;
  height: 48px;

  flex-shrink: 0;

  border-radius: 50%;

  background: linear-gradient(
    90deg,
    #eeeeee 25%,
    #f6f6f6 50%,
    #eeeeee 75%
  );

  background-size: 200% 100%;

  animation: shimmer 1.2s infinite linear;
}

.skeleton-text {
  flex: 1;

  display: flex;
  flex-direction: column;

  gap: 8px;

  min-width: 0;
}

.line {
  height: 12px;

  border-radius: 999px;

  background: linear-gradient(
    90deg,
    #eeeeee 25%,
    #f6f6f6 50%,
    #eeeeee 75%
  );

  background-size: 200% 100%;

  animation: shimmer 1.2s infinite linear;
}

.line-1 {
  width: 60%;
}

.line-2 {
  width: 40%;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

/* ========= DARK ========= */

html[data-theme='dark'] .skeleton-avatar,
html[data-theme='dark'] .line {
  background: linear-gradient(
    90deg,
    #333 25%,
    #444 50%,
    #333 75%
  );

  background-size: 200% 100%;
}

html[data-theme='dark'] .skeleton-card {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

/* ========= MOBILE ========= */

@media (max-width: 430px) {

  .skeleton-card {
    padding: 10px 0;

    gap: 12px;
  }

  .skeleton-avatar {
    width: 42px;
    height: 42px;
  }

  .skeleton-text {
    gap: 6px;
  }

  .line {
    height: 10px;
    border-radius: 999px;
  }

  .line-1 {
    width: 72%;
  }

  .line-2 {
    width: 52%;
  }
}

</style>